import React, { Suspense, lazy, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import GlobalStyles from 'styles/GlobalStyles';
import { css } from "styled-components/macro"; //eslint-disable-line
import tw from "twin.macro";
import styled from "styled-components";
import PoshMythsVsReality from "pages/PoshMythsVsReality";
import PenaltiesForNonCompliance from "pages/PenaltiesForNonCompliance";
import PoshComplianceChecklist from "pages/PoshComplianceChecklist";

// Loading component for Suspense fallback
const LoadingContainer = tw.div`flex items-center justify-center min-h-screen`;
const LoadingText = tw.div`text-2xl text-primary-500 font-semibold`;

const Loading = () => (
  <LoadingContainer>
    <LoadingText>Loading...</LoadingText>
  </LoadingContainer>
);

/*
 * This is the entry point component of this project. You can change the below exported default App component to any of
 * the prebuilt landing page components by uncommenting their import and export lines respectively.
 * See one of the landing page components to better understand how to import and render different components (Always
 * make sure if you are building your own page, the root component should be the AnimationRevealPage component. You can
 * disable the animation by using the disabled prop.
 *
 * The App component below is using React router to render the landing page that you see on the live demo website
 * and the component previews.
 *
 */

/* Use AnimationRevealPage as a wrapper component for your pages if you are building a custom one yourself */
// import AnimationRevealPage from "helpers/AnimationRevealPage.js";

/*
 * Hero section is the top most section on the page. It contains the header as well.
 * So you dont need to import headers
 * separately
 */

// import Hero from "components/hero/TwoColumnWithVideo.js";
// import Hero from "components/hero/TwoColumnWithInput.js";
// import Hero from "components/hero/TwoColumnWithFeaturesAndTestimonial.js";
// import Hero from "components/hero/TwoColumnWithPrimaryBackground.js";
// import Hero from "components/hero/FullWidthWithImage.js";
// import Hero from "components/hero/BackgroundAsImage.js";
// import Hero from "components/hero/BackgroundAsImageWithCenteredContent.js";

// import Features from "components/features/ThreeColSimple.js";
// import Features from "components/features/ThreeColWithSideImage.js";
// import Features from "components/features/ThreeColWithSideImageWithPrimaryBackground.js";
// import Features from "components/features/VerticalWithAlternateImageAndText.js";
// import Features from "components/features/DashedBorderSixFeatures";
// import MainFeature from "components/features/TwoColWithButton.js";
// import MainFeature from "components/features/TwoColSingleFeatureWithStats.js";
// import MainFeature2 from "components/features/TwoColSingleFeatureWithStats2.js";
// import MainFeature from "components/features/TwoColWithTwoHorizontalFeaturesAndButton.js";
// import FeatureWithSteps from "components/features/TwoColWithSteps.js";
// import FeatureStats from "components/features/ThreeColCenteredStatsPrimaryBackground.js";

// import Pricing from "components/pricing/ThreePlans.js";
// import Pricing from "components/pricing/ThreePlansWithHalfPrimaryBackground.js";
// import Pricing from "components/pricing/TwoPlansWithDurationSwitcher.js";

// import SliderCard from "components/cards/ThreeColSlider.js";
// import TrendingCard from "components/cards/TwoTrendingPreviewCardsWithImage.js";
// import Portfolio from "components/cards/PortfolioTwoCardsWithImage.js";
// import TabGrid from "components/cards/TabCardGrid.js";

// import Blog from "components/blogs/ThreeColSimpleWithImage.js";
// import Blog from "components/blogs/ThreeColSimpleWithImageAndDashedBorder.js";
// import Blog from "components/blogs/PopularAndRecentBlogPosts.js";
// import Blog from "components/blogs/GridWithFeaturedPost.js";

// import Testimonial from "components/testimonials/TwoColumnWithImage.js";
// import Testimonial from "components/testimonials/TwoColumnWithImageAndProfilePictureReview.js";
// import Testimonial from "components/testimonials/TwoColumnWithImageAndRating.js";
// import Testimonial from "components/testimonials/ThreeColumnWithProfileImage.js";
 //import Testimonial from "components/testimonials/SimplePrimaryBackground.js";

// import FAQ from "components/faqs/SimpleWithSideImage.js";
// import FAQ from "components/faqs/SingleCol.js";
// import FAQ from "components/faqs/TwoColumnPrimaryBackground.js";

// import ContactUsForm from "components/forms/SimpleContactUs.js";
// import ContactUsForm from "components/forms/TwoColContactUsWithIllustration.js";
// import SubscribeNewsLetterForm from "components/forms/SimpleSubscribeNewsletter.js";
//
// import GetStarted from "components/cta/GetStarted.js";
// import GetStarted from "components/cta/GetStartedLight.js";
// import DownloadApp from "components/cta/DownloadApp.js";

// import Footer from "components/footers/SimpleFiveColumn.js";
// import Footer from "components/footers/FiveColumnWithInputForm.js";
// import Footer from "components/footers/FiveColumnWithBackground.js";
// import Footer from "components/footers/FiveColumnDark.js";
// import Footer from "components/footers/MiniCenteredFooter.js";

/* Ready Made Pages (from demos folder) */
// import EventLandingPage from "demos/EventLandingPage.js";
// import HotelTravelLandingPage from "demos/HotelTravelLandingPage.js";
// import AgencyLandingPage from "demos/AgencyLandingPage.js";
// import SaaSProductLandingPage from "demos/SaaSProductLandingPage.js";
// import RestaurantLandingPage from "demos/RestaurantLandingPage.js";
// import HostingCloudLandingPage from "demos/HostingCloudLandingPage.js";

/* Inner Pages - Lazy Loaded for Performance */
// import LoginPage from "pages/Login.js";
// import SignupPage from "pages/Signup.js";
// import PricingPage from "pages/Pricing.js";

// Lazy load page components for better performance
const ServiceLandingPage = lazy(() => import("demos/ServiceLandingPage.js"));
const AboutUsPage = lazy(() => import("pages/AboutUs.js"));
const ContactUsPage = lazy(() => import("pages/ContactUs.js"));
const ContactUsTest = lazy(() => import("pages/ContactUsTest.js"));
const TermsOfServicePage = lazy(() => import("pages/TermsOfService.js"));
const ComponentRenderer = lazy(() => import("ComponentRenderer.js"));
const MainLandingPage = lazy(() => import("MainLandingPage.js"));
const ThankYouPage = lazy(() => import("ThankYouPage.js"));
const PrivacyPolicy = lazy(() => import("pages/PrivacyPolicy"));
const Posh = lazy(() => import("pages/Posh"));
const CippePage = lazy(() => import("pages/Cippe"));
const CippeDetailsPage = lazy(() => import("pages/CippeDetails"));
const CippeCourseDetailsPage = lazy(() => import("pages/CippeCourseDetails"));
const WhatIsCippePage = lazy(() => import("pages/WhatIsCippe"));
const ComplianceChecklistPage = lazy(() => import("pages/ComplianceChecklist"));
const PoshAct = lazy(() => import("pages/PoshAct"));
const ArticleTopics = lazy(() => import("pages/ArticleTopics"));
const PoshTrainingMandatoryIndia = lazy(() => import("pages/PoshTrainingMandatoryIndia"));
const RespectAtWork = lazy(() => import("pages/RespectAtWork"));
const DpdpaVsGdpr = lazy(() => import("pages/DpdpaVsGdpr"));
const PoshAndDpdpaOverlap = lazy(() => import("pages/PoshAndDpdpaOverlap"));
const ELearningModules = lazy(() => import("pages/ELearningModules"));
const BasicPoshAwarenessCourse = lazy(() => import("pages/BasicPoshAwarenessCourse"));
const AdvancedPoshAwarenessCourse = lazy(() => import("pages/AdvancedPoshAwarenessCourse"));
const MixedBundlesCourse = lazy(() => import("pages/MixedBundlesCourse"));
const ConsultingAndAuditing = lazy(() => import("pages/ConsultingAndAuditing"));
const InPersonTraining = lazy(() => import("pages/InPersonTraining"));
const ICExternalMemberEmpanelment = lazy(() => import("pages/ICExternalMemberEmpanelment"));
const ComplaintHandling = lazy(() => import("pages/ComplaintHandling"));
const Disclaimer = lazy(() => import("pages/Disclaimer"));
const NotFound = lazy(() => import("pages/NotFound"));

// import BlogIndexPage from "pages/BlogIndex.js";

export default function App() {
  useEffect(() => {
    const isProtectedImageTarget = (target) => target instanceof Element && target.closest("img");

    const preventImageContextMenu = (event) => {
      if (isProtectedImageTarget(event.target)) {
        event.preventDefault();
      }
    };

    const preventImageDrag = (event) => {
      if (isProtectedImageTarget(event.target)) {
        event.preventDefault();
      }
    };

    document.addEventListener("contextmenu", preventImageContextMenu);
    document.addEventListener("dragstart", preventImageDrag);

    return () => {
      document.removeEventListener("contextmenu", preventImageContextMenu);
      document.removeEventListener("dragstart", preventImageDrag);
    };
  }, []);

  // If you want to disable the animation just use the disabled `prop` like below on your page's component
  // return <AnimationRevealPage disabled>xxxxxxxxxx</AnimationRevealPage>;


  return (
    <>
      <GlobalStyles />
      <Router>
        <Suspense fallback={<Loading />}>
          <Routes>
            <Route path="/components/:type/:subtype/:name" element={<ComponentRenderer />} />
            <Route path="/components/:type/:name" element={<ComponentRenderer />} />
            <Route path="/thank-you" element={<ThankYouPage />} />
            <Route path="/" element={<ServiceLandingPage />} />
            <Route path="/about-us" element={<AboutUsPage />} />
            <Route path="/prevention-of-sexual-harassment" element={<Posh />} />
            <Route path="/cippe" element={<CippePage />} />
            <Route path="/cippe-details" element={<CippeDetailsPage />} />
            <Route path="/cippe-course-details" element={<CippeCourseDetailsPage />} />
            <Route path="/what-is-cippe" element={<WhatIsCippePage />} />
            <Route path="/compliance-checklist" element={<ComplianceChecklistPage />} />
            <Route path="/contact-us" element={<ContactUsPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/term-and-services" element={<TermsOfServicePage />} />
            <Route path="/disclaimer" element={<Disclaimer />} />
            <Route path="/posh-myth-vs-reality" element={<PoshMythsVsReality />} />
            <Route path="/penalties-for-non-compliance-of-posh-act" element={<PenaltiesForNonCompliance />} />
            <Route path="/posh-compliance-check-list" element={<PoshComplianceChecklist />} />
            <Route path="/posh-training-mandatory-india" element={<PoshTrainingMandatoryIndia />} />
            <Route path="/respect-at-work" element={<RespectAtWork />} />
            <Route path="/dpdpa-vs-gdpr" element={<DpdpaVsGdpr />} />
            <Route path="/posh-and-dpdpa-overlap" element={<PoshAndDpdpaOverlap />} />
            <Route path="/posh-act" element={<PoshAct />} />
            <Route path="/blogs" element={<ArticleTopics />} />
            <Route path="/e-learning-modules" element={<ELearningModules />} />
            <Route path="/basic-posh-awareness-course" element={<BasicPoshAwarenessCourse />} />
            <Route path="/advanced-posh-awareness-course" element={<AdvancedPoshAwarenessCourse />} />
            <Route path="/mixed-bundles" element={<MixedBundlesCourse />} />
            <Route path="/consulting-and-auditing" element={<ConsultingAndAuditing />} />
            <Route path="/in-person-training" element={<InPersonTraining />} />
            <Route path="/ic-external-member-empanelment" element={<ICExternalMemberEmpanelment />} />
            <Route path="/complaint-handling" element={<ComplaintHandling />} />

            {/* Redirect invalid URLs to relevant pages */}
            <Route path="/manager-leadership" element={<Posh />} />
            <Route path="/employee-awareness" element={<Posh />} />
            <Route path="/ic-training" element={<Posh />} />
            <Route path="/posh" element={<Posh />} />

            {/* Catch-all route for 404 - must be last */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </Router>
    </>
  );
}

// export default EventLandingPage;
// export default HotelTravelLandingPage;
// export default AgencyLandingPage;
// export default SaaSProductLandingPage;
// export default RestaurantLandingPage;
// export default ServiceLandingPage;
// export default HostingCloudLandingPage;

// export default LoginPage;
// export default SignupPage;
// export default PricingPage;
// export default AboutUsPage;
// export default ContactUsPage;
// export default BlogIndexPage;
// export default TermsOfServicePage;
// export default PrivacyPolicyPage;

// export default MainLandingPage;
